<mat-nav-list class="sidebar">
  <a mat-list-item *ngFor="let link of items"
     routerLinkActive="active"
     [routerLink]="link.routerLink">
    <mat-icon matListIcon [svgIcon]="link.icon"></mat-icon>
    <span matLine>{{ link.title | translate }}</span>
  </a>

  <div mat-list-item class="sidebar-payment-btn">
    <app-payment-btn placement="mobile"></app-payment-btn>
  </div>
</mat-nav-list>
